import { default as indexzIuiiuXAUqMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/account/index.vue?macro=true";
import { default as loginrJOkNbIkx2Meta } from "D:/Out/MedCAT/MedCAT.Cms/pages/account/login.vue?macro=true";
import { default as settingsjxsyMTE2WvMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/account/settings.vue?macro=true";
import { default as index9QOImyRUGOMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/activity-log/index.vue?macro=true";
import { default as _91id_93QTVbbWWRDXMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/[id].vue?macro=true";
import { default as index0ffzqbYaicMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/index.vue?macro=true";
import { default as indexSaXcNs4vqfMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/app/index.vue?macro=true";
import { default as builderju4vQ6Vz0WMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/builder.vue?macro=true";
import { default as _91code_93VPwhhlxhkyMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/category/[code].vue?macro=true";
import { default as indexUreNwvQ5PCMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/chat/index.vue?macro=true";
import { default as indexqbdnRCHjaJMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/company/index.vue?macro=true";
import { default as _91id_93W9YununUGcMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/contract/[id].vue?macro=true";
import { default as _91id_93SwOZT50uUpMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/contract/document/[id].vue?macro=true";
import { default as indexgiwPS8A14TMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/contract/index.vue?macro=true";
import { default as index60lOxR3jnFMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/customer/index.vue?macro=true";
import { default as prescription_45dynamicsUPvmYtfTFMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/demo/prescription-dynamic.vue?macro=true";
import { default as index9KHTYXI8ZyMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/document-pending/index.vue?macro=true";
import { default as indexrx90LROPDaMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/documents/index.vue?macro=true";
import { default as index783NTDC9AwMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/facility/index.vue?macro=true";
import { default as indexAk6TV7bzICMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/index.vue?macro=true";
import { default as indexGZe1i2XKK0Meta } from "D:/Out/MedCAT/MedCAT.Cms/pages/original-document/index.vue?macro=true";
import { default as _91id_93rrSHv4Z54oMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/[id].vue?macro=true";
import { default as indexNpNWPlmiMnMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/index.vue?macro=true";
import { default as _91id_93ZMRxuMFXoVMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/[id].vue?macro=true";
import { default as indexG1ZPpZg1m2Meta } from "D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/index.vue?macro=true";
import { default as indexBQ5eJSrOoQMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/index.vue?macro=true";
import { default as indexlO1qXSnUOmMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/role/index.vue?macro=true";
import { default as index8p5ECLmIjMMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/system-config/index.vue?macro=true";
import { default as file_45managerESliMH8m1tMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/test/file-manager.vue?macro=true";
import { default as file_45viewergfrnfbMk9JMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/test/file-viewer.vue?macro=true";
import { default as pdf2imagezlJ00foP3KMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/test/pdf2image.vue?macro=true";
import { default as testUIMemHHIOUMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/test.vue?macro=true";
import { default as test2KOeDOi7y6uMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/test2.vue?macro=true";
import { default as _91id_93FVtWwC3ehGMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/user-report/[id].vue?macro=true";
import { default as indexh3KqzADpePMeta } from "D:/Out/MedCAT/MedCAT.Cms/pages/user-report/index.vue?macro=true";
export default [
  {
    name: "account___vi",
    path: "/account",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: loginrJOkNbIkx2Meta || {},
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: loginrJOkNbIkx2Meta || {},
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/login.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/account/settings.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/activity-log/index.vue")
  },
  {
    name: "admin-form-config-id___vi",
    path: "/admin/form-config/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config-id___en",
    path: "/en/admin/form-config/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/[id].vue")
  },
  {
    name: "admin-form-config___vi",
    path: "/admin/form-config",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/index.vue")
  },
  {
    name: "admin-form-config___en",
    path: "/en/admin/form-config",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/admin/form-config/index.vue")
  },
  {
    name: "app___vi",
    path: "/app",
    meta: indexSaXcNs4vqfMeta || {},
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    meta: indexSaXcNs4vqfMeta || {},
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/app/index.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/builder.vue")
  },
  {
    name: "category-code___vi",
    path: "/category/:code()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "category-code___en",
    path: "/en/category/:code()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/category/[code].vue")
  },
  {
    name: "chat___vi",
    path: "/chat",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/chat/index.vue")
  },
  {
    name: "chat___en",
    path: "/en/chat",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/chat/index.vue")
  },
  {
    name: "company___vi",
    path: "/company",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/company/index.vue")
  },
  {
    name: "company___en",
    path: "/en/company",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/company/index.vue")
  },
  {
    name: "contract-id___vi",
    path: "/contract/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/[id].vue")
  },
  {
    name: "contract-id___en",
    path: "/en/contract/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/[id].vue")
  },
  {
    name: "contract-document-id___vi",
    path: "/contract/document/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract-document-id___en",
    path: "/en/contract/document/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/document/[id].vue")
  },
  {
    name: "contract___vi",
    path: "/contract",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/index.vue")
  },
  {
    name: "contract___en",
    path: "/en/contract",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/contract/index.vue")
  },
  {
    name: "customer___vi",
    path: "/customer",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/customer/index.vue")
  },
  {
    name: "customer___en",
    path: "/en/customer",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/customer/index.vue")
  },
  {
    name: "demo-prescription-dynamic___vi",
    path: "/demo/prescription-dynamic",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "demo-prescription-dynamic___en",
    path: "/en/demo/prescription-dynamic",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/demo/prescription-dynamic.vue")
  },
  {
    name: "document-pending___vi",
    path: "/document-pending",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/document-pending/index.vue")
  },
  {
    name: "document-pending___en",
    path: "/en/document-pending",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/document-pending/index.vue")
  },
  {
    name: "documents___vi",
    path: "/documents",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/documents/index.vue")
  },
  {
    name: "facility___vi",
    path: "/facility",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/facility/index.vue")
  },
  {
    name: "facility___en",
    path: "/en/facility",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/facility/index.vue")
  },
  {
    name: "index___vi",
    path: "/",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/index.vue")
  },
  {
    name: "original-document___vi",
    path: "/original-document",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/original-document/index.vue")
  },
  {
    name: "original-document___en",
    path: "/en/original-document",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/original-document/index.vue")
  },
  {
    name: "payment-request-csyt-id___vi",
    path: "/payment-request/csyt/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt-id___en",
    path: "/en/payment-request/csyt/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/[id].vue")
  },
  {
    name: "payment-request-csyt___vi",
    path: "/payment-request/csyt",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-csyt___en",
    path: "/en/payment-request/csyt",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/csyt/index.vue")
  },
  {
    name: "payment-request-ctbh-id___vi",
    path: "/payment-request/ctbh/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh-id___en",
    path: "/en/payment-request/ctbh/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/[id].vue")
  },
  {
    name: "payment-request-ctbh___vi",
    path: "/payment-request/ctbh",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request-ctbh___en",
    path: "/en/payment-request/ctbh",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/ctbh/index.vue")
  },
  {
    name: "payment-request___vi",
    path: "/payment-request",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/index.vue")
  },
  {
    name: "payment-request___en",
    path: "/en/payment-request",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/payment-request/index.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/role/index.vue")
  },
  {
    name: "system-config___vi",
    path: "/system-config",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/system-config/index.vue")
  },
  {
    name: "system-config___en",
    path: "/en/system-config",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/system-config/index.vue")
  },
  {
    name: "test___vi",
    path: "/test",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___vi",
    path: "file-manager",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "file-viewer",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "pdf2image",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test___en",
    path: "/en/test",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test.vue"),
    children: [
  {
    name: "test-file-manager___en",
    path: "file-manager",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "file-viewer",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "pdf2image",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test/pdf2image.vue")
  }
]
  },
  {
    name: "test2___vi",
    path: "/test2",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test2.vue")
  },
  {
    name: "test2___en",
    path: "/en/test2",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/test2.vue")
  },
  {
    name: "user-report-id___vi",
    path: "/user-report/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report-id___en",
    path: "/en/user-report/:id()",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/user-report/[id].vue")
  },
  {
    name: "user-report___vi",
    path: "/user-report",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/user-report/index.vue")
  },
  {
    name: "user-report___en",
    path: "/en/user-report",
    component: () => import("D:/Out/MedCAT/MedCAT.Cms/pages/user-report/index.vue")
  }
]